
export function UserFullName({profile}) {

    return (
        <>{profile.firstName} {profile.lastName}</>
    )

}